<template>
  <div class="d-flex justify-content-center mb-3">
    <b-spinner v-if="status" style="width: 6rem; height: 6rem;" label="Wait.." variant="success" />
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data: () => ({
    status: true
  }),
  mounted () {
    this.setSuccessPayment()
  },
  methods: {
    async setSuccessPayment () {
      this.$root.$refs.loading.start()
      const apiUrl = process.env.VUE_APP_API_URL
      const apiKey = btoa(process.env.VUE_APP_API_KEY)
      if (this.$route.params.id) {
        const id = this.$route.params.id
        await axios.get(apiUrl + 'paypal/ec-checkout-success/' + id + window.location.search + '&domain=' + window.location.origin).then(resp => {
          if (resp.data) {
            this.$root.$refs.loading.finish()
            this.status = false
            this.$router.push({ name: 'checkout.success' })
          } else {
            console.log('Error...')
            this.status = true
            this.$root.$refs.loading.finish()
          }
        })
      }
    }
  }
}
</script>
